
    <div class="ng2-smart-title">{{ actionsColumnTitle }}</div>
  